import {forwardRef} from 'react';
import {Button, type ButtonProps} from '../button';
import {cn} from '../lib/cn';

export type WideButtonProps = Omit<ButtonProps, 'size'>;

export const WideButton = forwardRef<HTMLButtonElement, WideButtonProps>(
  ({className, disabled, ...props}, ref) => (
    <Button
      ref={ref}
      variant="ghost"
      className={cn(
        'min-h-[84px] w-full max-w-[712px] flex-row justify-center rounded-md bg-[color-mix(in_srgb,var(--button-primary-bg)_6%,white)] text-[var(--button-primary-bg)] shadow-none',
        'transition-all duration-[70ms] ease-in-out hover:opacity-70',
        disabled && 'opacity-10',
        className,
      )}
      disabled={disabled}
      {...props}
    />
  ),
);

WideButton.displayName = 'WideButton';
